import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import * as IntacctActions from '../Intacct/actions';
import * as ItemsActions from '../Items/actions';
import * as LocalActions from '../Local/actions';
import * as TimeTypesActions from '../TimeTypes/actions';
import * as UserActions from '../User/actions';

import { createClient } from '../../graphql';
import { GetCompanyDocument } from '../../graphql/generated';
import toastr from '../../helpers/toastr';
import I18njs from 'i18n-js';
import { selectToken } from '../selectors';

export function* getCompanyRequestSaga() {
  try {
    const token = selectToken(store.getState());
    const apolloClient = yield createClient({ token });
    const res = yield apolloClient.query({
      query: GetCompanyDocument,
    });
    const fetchedCompany = res.data?.company || {};
    yield put(actions.getCompanyRequestSuccess(fetchedCompany));

    // Fetch resources based on company settings
    if (fetchedCompany.showItem) yield put(ItemsActions.getItemsRequest({ activeOnly: 'true' }));
    if (fetchedCompany.showTimeType) yield put(TimeTypesActions.getTimeTypesRequest());
  } catch (error) {
    yield put(actions.getCompanyRequestFailure(error));
  }
}

export function* getCompanyLogoRequestSaga() {
  try {
    const res = yield send({
      url: '/companies/logo',
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getCompanyLogoRequestSuccess(res));
  } catch (error) {
    yield put(actions.getCompanyLogoRequestFailure(error));
  }
}

export function* selectCompanyEntityRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/companies/${store.getState().user.data.company.id}/set-entity`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.selectCompanyEntityRequestSuccess(res));
    yield put(IntacctActions.intacctSyncRequest());
    yield put(actions.getCompanyRequest());
    toastr.success(I18njs.t('settings.advanced.EntitySetSuccess'));
  } catch (error) {
    yield put(actions.selectCompanyEntityRequestFailure(error));
  }
}

export function* updateCompanyRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/companies/${store.getState().user.data.company.id}`,
      method: 'PUT',
      data: payload.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateCompanyRequestSuccess(res));
  } catch (error) {
    yield put(actions.updateCompanyRequestFailure(error));
  }
}

/**
 * DEACTIVATE COMPANY
 */
export function* deactivateCompanyRequestSaga() {
  try {
    const company = store.getState().company.data;
    const token = selectToken(store.getState());
    const res = yield send({
      url: `/companies/${company.id}/archive`,
      method: 'POST',
      token,
    });
    yield put(actions.deactivateCompanyRequestSuccess(res));
    yield put(UserActions.logoutRequest({ dontCheckForUnauthorized: true, token }));
    yield put(LocalActions.showHideDeactivateCompanyModal(company.name));
  } catch (error) {
    yield put(actions.deactivateCompanyRequestFailure(error));
  }
}
